// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3QF_k","has-icon":"Button_has-icon__1eA2A","outlined":"Button_outlined__1slbo","small":"Button_small__1zbeU","textLight":"Button_textLight__3ml6T"};